import { Box, Button, Callout } from "@radix-ui/themes";

export interface OrdersReplacementFeedbackPresentationProps {
  contained: boolean;
  message?: string;
  onDismiss?: () => void;
}

export const OrdersReplacementFeedbackPresentation = ({
  contained,
  message,
  onDismiss,
}: OrdersReplacementFeedbackPresentationProps) => {
  if (!message) {
    return null;
  }

  return (
    <Box px={contained ? "2" : undefined}>
      <Callout.Root color="green" role="status">
        <Callout.Text>{message}</Callout.Text>
        <Button
          type="button"
          size="1"
          variant="ghost"
          color="green"
          onClick={onDismiss}
          aria-label="Dismiss replacement feedback"
        >
          Dismiss
        </Button>
      </Callout.Root>
    </Box>
  );
};
